const notFalsey = <T>(item: T | null | undefined | false | ''): item is T => Boolean(item);

export { notFalsey };
